// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bankCarousel_tabPane {
  color: white !important;
  font-size: 30px;
}

.ant-tabs-ink-bar::after {
  background: #f0592a !important;
  height: 5px !important;
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}

.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  display: flex;
  padding: 20px !important;
  font-size: 1.5vw;
  background: transparent;
  border: 0;
  outline: none;
  cursor: pointer;
}
@media (max-width: 576px) {
  .bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab {
    padding: 11px !important;
  }
}

.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,
:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {
  border-bottom: 0px solid #f0592a;
  border-top: 0px solid #f0592a;
}

.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab + .ant-tabs-tab {
  padding: 20px !important;
  margin: 0;
}
@media (min-width: 2560px) {
  .bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab + .ant-tabs-tab {
    padding: 100px !important;
  }
}
@media (max-width: 576px) {
  .bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab + .ant-tabs-tab {
    padding: 11px !important;
  }
}

.bankCarousel_tabPane .ant-tabs-tab {
  font-size: 1.5vw;
  font-weight: 400;
  color: #fff !important;
  border-bottom: 1px solid #fff !important;
}
@media (min-width: 2560px) {
  .bankCarousel_tabPane .ant-tabs-tab {
    font-size: 3vw !important;
  }
}
@media (max-width: 991px) {
  .bankCarousel_tabPane .ant-tabs-tab {
    font-size: 4vw !important;
  }
}
@media (max-width: 768px) {
  .bankCarousel_tabPane .ant-tabs-tab {
    font-size: 4vw;
  }
}
@media (max-width: 576px) {
  .bankCarousel_tabPane .ant-tabs-tab {
    font-size: 4vw;
  }
}

.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible),
:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab-remove:focus:not(:focus-visible),
:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab-btn:active,
:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab-remove:active {
  color: #fff !important;
}

.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab:hover {
  color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/BankCarousel/bankCarousel.scss"],"names":[],"mappings":"AACE;EACE,uBAAA;EACA,eAAA;AAAJ;;AAGA;EACE,8BAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAAF;;AAGA;EAGE,WAAA;AAFF;;AAIA;EAEE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;AAFF;AAGE;EAZF;IAaI,wBAAA;EAAF;AACF;;AAEA;;EAOE,gCAAA;EACA,6BAAA;AAJF;;AAOA;EAGE,wBAAA;EACA,SAAA;AANF;AAOE;EALF;IAMI,yBAAA;EAJF;AACF;AAKE;EARF;IASI,wBAAA;EAFF;AACF;;AAIA;EACE,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,wCAAA;AADF;AAEE;EALF;IAMI,yBAAA;EACF;AACF;AAAE;EARF;IASI,yBAAA;EAGF;AACF;AAFE;EAXF;IAYI,cAAA;EAKF;AACF;AAJE;EAdF;IAeI,cAAA;EAOF;AACF;;AALA;;;;EAOE,sBAAA;AAKF;;AAHA;EAEE,sBAAA;AAKF","sourcesContent":[".bankCarousel {\n  &_tabPane {\n    color: white !important;\n    font-size: 30px;\n  }\n}\n.ant-tabs-ink-bar::after {\n  background: #f0592a !important;\n  height: 5px !important;\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs\n  .ant-tabs-tab.ant-tabs-tab-active\n  .ant-tabs-tab-btn {\n  color: #fff;\n}\n.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs\n  .ant-tabs-tab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  display: flex;\n  padding: 20px !important ;\n  font-size: 1.5vw;\n  background: transparent;\n  border: 0;\n  outline: none;\n  cursor: pointer;\n  @media (max-width: 576px) {\n    padding: 11px !important ;\n  }\n}\n.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs\n  > .ant-tabs-nav\n  .ant-tabs-nav-list,\n:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs\n  > div\n  > .ant-tabs-nav\n  .ant-tabs-nav-list {\n  border-bottom: 0px solid #f0592a;\n  border-top: 0px solid #f0592a;\n}\n\n.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs\n  .ant-tabs-tab\n  + .ant-tabs-tab {\n  padding: 20px !important;\n  margin: 0;\n  @media (min-width: 2560px) {\n    padding: 100px !important;\n  }\n  @media (max-width: 576px) {\n    padding: 11px !important ;\n  }\n}\n.bankCarousel_tabPane .ant-tabs-tab {\n  font-size: 1.5vw;\n  font-weight: 400;\n  color: #fff !important;\n  border-bottom: 1px solid #fff !important;\n  @media (min-width: 2560px) {\n    font-size: 3vw !important;\n  }\n  @media (max-width: 991px) {\n    font-size: 4vw !important;\n  }\n  @media (max-width: 768px) {\n    font-size: 4vw;\n  }\n  @media (max-width: 576px) {\n    font-size: 4vw;\n  }\n}\n.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs\n  .ant-tabs-tab-btn:focus:not(:focus-visible),\n:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs\n  .ant-tabs-tab-remove:focus:not(:focus-visible),\n:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs .ant-tabs-tab-btn:active,\n:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs\n  .ant-tabs-tab-remove:active {\n  color: #fff !important;\n}\n.bankCarousel_tabPane:where(.css-dev-only-do-not-override-10ed4xt).ant-tabs\n  .ant-tabs-tab:hover {\n  color: #fff !important;\n}\n\n\n// :where(.css-10ed4xt).ant-tabs .ant-tabs-tab:hover {\n//   color: #fff !important;\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
